import { MessageListResponse } from '@aipb/gulliver/personal-content/model';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PersonalContentApiService } from '../personal-content-api.service';
import { CoopApiInterface } from './coop-api.interface';
import { MessageSendToCollectionParams, MessageSendToUserParams } from './coop-api.params';

@Injectable({
  providedIn: 'root'
})
export class CoopApiService implements CoopApiInterface {
  private api = inject(PersonalContentApiService);

  messageList(filters: Record<string, string[]> = {}): Observable<MessageListResponse> {
    return this.api.post('messageList', filters);
  }

  messageSend(params: MessageSendToUserParams | MessageSendToCollectionParams): Observable<any> {
    return this.api.post('messageSend', params);
  }
}
